import { UserEmailEntity } from '../entities';
import { authResource } from './Auth';
import { paginatedSchema } from '../utils/schemas';
export const OrganizationEncryptionOwnerResource = authResource({
    path: '/organizations/:organizationId/encryptions/owners/:ownerId?',
    searchParams: {},
    schema: UserEmailEntity
})
    .extend('getList', {
    schema: paginatedSchema(UserEmailEntity)
})
    .extend((BaseResource) => ({
    getBulkList: BaseResource.getList.extend({
        method: 'POST',
        body: {},
        schema: paginatedSchema(UserEmailEntity),
        sideEffect: false
    })
}));
